import { SalesOrderStatus } from "./enums/sales-order-status.enum"

export const salesOrderStatusLabels=[
{
    key:SalesOrderStatus.Draft.toString(),
    textClass: 'text-blue-600',
    bgClass: 'bg-blue-600/10',
},
,{
    key:SalesOrderStatus.Open.toString(),
    textClass: 'text-indigo-600',
    bgClass: 'bg-indigo-600/10',
}
,{
    key:SalesOrderStatus.PartiallyPosted.toString(),
    textClass: 'text-emerald-600',
    bgClass: 'bg-emerald-600/10',
},
{
    key:SalesOrderStatus.Posted.toString(),
    textClass: 'text-yellow-600',
    bgClass: 'bg-yellow-600/10',
},

 ]